import { Leaves } from "../../utils/types/common";
import i18next from "./i18n";
import { Resources } from "./locales/resources";

export type ResourcesKey =
  | `${keyof Resources["ar"]}:${Leaves<Resources["ar"][keyof Resources["ar"]]>}`
  | Leaves<Resources["ar"][keyof Resources["ar"]]>;

export const translate = (
  key: ResourcesKey,
  options: { [key: `val${number}`]: string } = {}
) => {
  return i18next.t(key, {
    defaultValue: "",
    ...options,
  });
};
